<form autocomplete="off" class="p-0" novalidate [formGroup]="photoSignDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-2">
            <h5 class="main-content-label fw-bold mb-3">Photo & Signature</h5>

            <div class="row g-3">
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100">
                        <label class="form-label small fw-bold mb-1">Upload Photo</label>
                        <div class="upload-container">
                            <img *ngIf="!userImage"
                                 src="../../assets/images/user2.png"
                                 class="default-img" />
                            
                            <img *ngIf="userImage"
                                 [src]="userImage"
                                 class="img-preview" />
                        </div>

                        <div class="text-center mt-2" *ngIf="updateButton">
                            <input #fileUpload type="file" hidden (change)="onChange1($event)" />
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-3 py-1"
                                    matTooltip="JPG/JPEG • 200×230px to 500×530px • Max 50KB"
                                    (click)="fileUpload.click()">
                                <i class="ai-upload me-1"></i>Upload Photo
                            </button>
                        </div>

                        <mat-error *ngIf="photoSignDetailsForm.controls['StuPhoto'].touched 
                                && photoSignDetailsForm.controls['StuPhoto'].errors?.required"
                                   class="mat-error text-center">
                            Required
                        </mat-error>
                    </div>
                </div>

                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100">
                        <label class="form-label small fw-bold mb-1">Upload Signature</label>

                        <div class="signature-container">
                            <img *ngIf="!signatureImage"
                                 src="../../assets/images/sign.png"
                                 class="default-sign" />

                            <img *ngIf="signatureImage"
                                 [src]="signatureImage"
                                 class="img-preview" />
                        </div>

                        <div class="text-center mt-2" *ngIf="updateButton">
                            <input #fileUpload2 type="file" hidden (change)="onChangeSign($event)" />
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-3 py-1"
                                    matTooltip="JPG/JPEG • 140×60px to 300×300px • Max 20KB"
                                    (click)="fileUpload2.click()">
                                <i class="ai-upload me-1"></i>Upload Sign
                            </button>
                        </div>

                        <mat-error *ngIf="photoSignDetailsForm.controls['StuSignature'].touched 
                                && photoSignDetailsForm.controls['StuSignature'].errors?.required"
                                   class="mat-error text-center">
                            Required
                        </mat-error>
                    </div>
                </div>

                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-2 h-100">
                        
                        <label class="form-label small fw-bold mb-1">
                            ABC Id <span class="redCol">*</span>
                        </label>
                        
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input required maxlength="12"
                                   matInput
                                   class="color"
                                   formControlName="StuABCId2"
                                   placeholder="Enter ABC Id"
                                   onkeydown="return event.keyCode!=13;">
                            
                            <mat-error *ngIf="photoSignDetailsForm.controls['StuABCId2'].touched 
                                         && photoSignDetailsForm.controls['StuABCId2'].errors?.required">
                                Required
                            </mat-error>

                            <mat-error *ngIf="photoSignDetailsForm.controls['StuABCId2'].touched 
                                         && photoSignDetailsForm.controls['StuABCId2'].errors?.pattern">
                                Invalid Format
                            </mat-error>
                        </mat-form-field>

                        <div class="requirements-box mt-2">
                            <div class="fw-bold">Photo Requirements</div>
                            <div>• JPG/JPEG • Max 50KB</div>
                            <div>• 200 x 230 pixels</div>
                        </div>

                        <div class="requirements-box mt-1">
                            <div class="fw-bold">Signature Requirements</div>
                            <div>• JPG/JPEG • Max 20KB</div>
                            <div>• 140 x 60 pixels</div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="button-container d-flex justify-content-end">
            
                <button id="Back"
                        type="button"
                        [mat-dialog-close]="true"
                        class="btn btn-sm btn-outline-secondary px-3 py-1 me-2">
                    <i class="ai-arrow-left me-1 small"></i>Back
                </button>

                <button *ngIf="updateButton"
                        type="button"
                        [disabled]="disabled || isSaving"
                        (click)="updateCheck()"
                        class="btn btn-sm btn-primary px-3 py-1">
                    <i class="ai-save me-1 small"></i>
                    <span *ngIf="!isSaving">Update</span>
                    <span *ngIf="isSaving">Updating...</span>
                </button>

            </div>

        </div>
    </div>
</form>